import React from 'react';
import {
  Navbar, ScrollArea, createStyles,
} from '@mantine/core';
import {
  IconNotes,
  IconCode,
  IconBrandGithub,
  IconBrandLinkedin,
} from '@tabler/icons';
import LinksGroup from './LinkGroup';
import Constants from '../../config/constants';

const sidebarLinks = [
  {
    labelKey: 'CV',
    icon: IconNotes,
    initiallyOpened: true,
    mainRoute: '/',
    links: [
      { labelKey: 'experience.title', link: '/', hash: 'experience' },
      { labelKey: 'languages.title', link: '/', hash: 'languages' },
      { labelKey: 'education.title', link: '/', hash: 'education' },
      { labelKey: 'courses.title', link: '/', hash: 'courses' },
      { labelKey: 'abilities.title', link: '/', hash: 'abilities' },
    ],
  },
  { labelKey: 'Github', icon: IconBrandGithub, mainRoute: Constants.GITHUB_LINK },
  { labelKey: 'LinkedIn', icon: IconBrandLinkedin, mainRoute: Constants.LINKEDIN_LINK },
  {
    labelKey: 'portfolio.title',
    icon: IconCode,
    mainRoute: '/portfolio',
    initiallyOpened: true,
    links: [
      { labelKey: 'CV Online', link: '/portfolio', hash: 'cvonline' },
      { labelKey: 'Dice and Roll', link: '/portfolio', hash: 'diceandroll' },
      { labelKey: 'Spotivision', link: '/portfolio', hash: 'spotivision' },
      { labelKey: 'My Scorewiz', link: '/portfolio', hash: 'myScorewiz' },
    ],
  },
];

const useStyles = createStyles((theme) => ({
  navbar: {
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
    paddingBottom: 0,
    minWidth: '200px !important',
  },

  header: {
    padding: theme.spacing.md,
    paddingTop: 0,
    marginLeft: -theme.spacing.md,
    marginRight: -theme.spacing.md,
    color: theme.colorScheme === 'dark' ? theme.white : theme.black,
    borderBottom: `1px solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
    }`,
  },

  links: {
    marginLeft: -theme.spacing.md,
    marginRight: -theme.spacing.md,
  },

  linksInner: {
  },

  footer: {
    marginLeft: -theme.spacing.md,
    marginRight: -theme.spacing.md,
    borderTop: `1px solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
    }`,
  },
}));

interface NavbarNestedProps {
  hidden: boolean;
  toggleNavbarOpened: Function;
}

export default function NavbarNested({ hidden, toggleNavbarOpened }: NavbarNestedProps) {
  const { classes } = useStyles();
  const links = sidebarLinks.map((item) => (
    <LinksGroup {...item} key={item.labelKey} toggleNavbarOpened={toggleNavbarOpened} />));

  return (
    <Navbar hidden={hidden} hiddenBreakpoint="md" height={800} width={{ sm: 300 }} p="md" className={classes.navbar}>
      <Navbar.Section grow className={classes.links} component={ScrollArea}>
        <div className={classes.linksInner}>{links}</div>
      </Navbar.Section>
    </Navbar>
  );
}
